import sharedMutations from "@/store/utils/shared-mutations";

export default {
  ...sharedMutations
};
